import { fontFamily, isRtl, isDevelopment} from '../../library/constants';
import { isIE, getWidthOfText, isMobilePhone, centerXFanchart, centerYFanchart, urlGet  } from '../../library/calc';
import { cloneDeep } from 'lodash';
import Crop from './crop';

import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";  // https://pdfmake.github.io/docs/document-definition-object/styling/

pdfMake.vfs = pdfFonts.pdfMake.vfs;

class Pdf extends Crop {

  pdfContentArray = [];
  buildPDFContentArray({croppedDataURL, pageCurrent}){

    let pdfPrintHeight = this.pdfPrintWidth / this.widthHeightRatio;
    pdfPrintHeight = pdfPrintHeight * (this.state.page / this.portion);

    const maxPdfPrintHeight = this.pdfPrintWidth / this.pdFLandscapeRatio + ( this.lowerPrintRes ? 5: 0);

    let pageObj = {
      image: croppedDataURL,
      width: this.pdfPrintWidth,
      height: ( pdfPrintHeight > maxPdfPrintHeight ? maxPdfPrintHeight : pdfPrintHeight),
      margin: [ 0, this.halfPDFPadding, 0, this.halfPDFPadding]
    }

    if(pageCurrent < this.state.page){
      pageObj = {
        ...pageObj,
        pageBreak: 'after'
      }
    }

    if(pageCurrent <= this.state.page){
      this.pdfContentArray.push(pageObj)
    }
  }

  translate(phrase, description){
    return typeof(window.trl) !== 'undefined' ? window.trl(phrase, description): phrase
  }

  getTrArrayLines({nodeObj}){
    const { nm } = nodeObj;
    const fullnameTextPhrase = ( typeof(window.trl) !== 'undefined' ? window.trl(`{profile}'s Tree`, 'Tree legend', { profile: nm }): `${nm}'s Tree`)
    const fullnameTextPhraseArray = fullnameTextPhrase.split(" ");
    const maxLineLength = 100;
    let soFarEachWordCombinedLength = 0;
    let wordsArray = [];
    let trLinesArray = [];
    let linesWidthArray = [];
    fullnameTextPhraseArray.forEach((eachWord, idx)=>{
      const eachWordWidth = getWidthOfText({txt: eachWord, fontname: `${fontFamily}`, fontsize: `14px`});
      soFarEachWordCombinedLength += eachWordWidth;
      wordsArray.push(eachWord);
      if( soFarEachWordCombinedLength > maxLineLength){
        linesWidthArray.push(soFarEachWordCombinedLength);
        soFarEachWordCombinedLength = 0;
        trLinesArray.push(wordsArray.join(' ').trim());
        wordsArray = [];
      }
    });
    if( wordsArray.length > 0){
      trLinesArray.push(wordsArray.join(' ').trim());
    }
    const largestWidthOftrLines = Math.max(...linesWidthArray);
    return { largestWidthOftrLines, trLinesArray };
  }

  buildFrontLegend(){

      let frontLegendWidth = 180;
      const legendHeight = 100;
      const fullnameTextPhraseStartingYPos = 40;

      var date = new Date();
      const translatedDate = (typeof(window.trl) !== 'undefined' ? window.trl("{months}/{days}/{years}", 'Partial Date', {months: date.getMonth() +  1, days: date.getDate(), years: date.getFullYear()}): '--' )

      const nodeObj = this.props.nodeObjs[this.props.focusNode];
      const geniLogoImg = document.getElementById("genilogo");
      const geniLogoWidth = 125;
      const genLogoHeight = geniLogoWidth / 3.05769231 ;
      geniLogoImg.style.width = `${geniLogoWidth}px`

      const legendCanvas = document.getElementById("legendCanvas");
      const ctx = legendCanvas.getContext("2d");

      let frontLegendContentLengthArray = [];
      const { largestWidthOftrLines, trLinesArray } = this.getTrArrayLines({nodeObj});
      frontLegendContentLengthArray.push(largestWidthOftrLines)

      this.lengthOfLegendNameArray = trLinesArray.length;
      const shiftNextLineDown = 20;
      this.shiftLegendBoxUp = (this.lengthOfLegendNameArray * shiftNextLineDown) - shiftNextLineDown;
      const shiftDownForLegendNameArray = ( shiftNextLineDown * this.lengthOfLegendNameArray);
      const countPhraseYPos = fullnameTextPhraseStartingYPos + shiftDownForLegendNameArray;
      const datePhraseYPos = shiftNextLineDown + countPhraseYPos;

      /*
        Profile name's tree
       */

      const rtlShift = 0;
      ctx.fillStyle = "darkgray";

      trLinesArray.forEach((trLine, idx)=>{

        const fullnameTextPhraseXPos = frontLegendWidth;
        const fullnameTextPhraseYPos = fullnameTextPhraseStartingYPos + ( idx * shiftNextLineDown);
        ctx.font = `13px Open Sans`;
        ctx.fillText(`${trLine}`, fullnameTextPhraseXPos- ( isRtl ? -rtlShift : 0), fullnameTextPhraseYPos);

      })

      const countPhrase = ( typeof(window.trl) !== 'undefined' ? window.trl(`Showing {count} people.`, 'Tree legend', { count: this.props.nodeCount }): `Showing ${this.props.nodeCount} people.`)
      ctx.font = `13px Open Sans`;
      ctx.fillText(countPhrase, frontLegendWidth- ( isRtl ? -rtlShift : 0), countPhraseYPos);
      frontLegendContentLengthArray.push(getWidthOfText({txt: countPhrase, fontname: `${fontFamily}`, fontsize: `14px`}));

      const datePhrase = ( typeof(window.trl) !== 'undefined' ? window.trl(`Printed on {date}.`, 'Tree legend', { date: translatedDate }): `Printed on ${date}.`)
      ctx.font = `13px Open Sans`;
      ctx.fillText(datePhrase, frontLegendWidth- ( isRtl ? -rtlShift : 0), datePhraseYPos);
      frontLegendContentLengthArray.push(getWidthOfText({txt: datePhrase, fontname: `${fontFamily}`, fontsize: `14px`}));


      // --------------

      ctx.font = `11px Arial`;
      ctx.fillStyle = "darkgray";
      ctx.fillText(`A MyHeritage Company`, frontLegendWidth- ( isRtl ? -155 : 137), 85);

      ctx.drawImage(geniLogoImg, frontLegendWidth - ( isRtl ? -30 : 145), 30, geniLogoWidth, genLogoHeight);

      if( this.state.bw ){
        var imgPixels = ctx.getImageData(0, 0, frontLegendWidth, legendHeight);
        for(var y = 0; y < imgPixels.height; y++){
         for(var x = 0; x < imgPixels.width; x++){
              var i = (y * 4) * imgPixels.width + x * 4;
              var avg = (imgPixels.data[i] + imgPixels.data[i + 1] + imgPixels.data[i + 2]) / 3;
              imgPixels.data[i] = avg;
              imgPixels.data[i + 1] = avg;
              imgPixels.data[i + 2] = avg;
         }
        }
        ctx.putImageData(imgPixels, 0, 0, 0, 0, imgPixels.width, imgPixels.height);
      }

      /*
        Legend Container
       */

      const largestWidthFrontLegendContent = Math.max(...frontLegendContentLengthArray);
      ctx.beginPath();
      ctx.lineWidth = '.5';
      ctx.rect(10, 10, frontLegendWidth + largestWidthFrontLegendContent + 20, legendHeight + ( this.lengthOfLegendNameArray === 1 ? 0: shiftDownForLegendNameArray - shiftNextLineDown));
      ctx.strokeStyle = "black";
      ctx.stroke();

      const dataURL = legendCanvas.toDataURL();

      const legendImg = document.getElementById("legendImg");
      legendImg.src = dataURL;
      return dataURL;
  }

  getExpandedTrLengthObj({ textArr, fontFamily, fontSize}){

      const trTextArr = textArr.map((text)=>{
        const origLength = getWidthOfText({txt: text.content, fontname: `${fontFamily}`, fontsize: `${fontSize}px`});
        const trText = this.translate(text.content, text.description);
        const trLength = getWidthOfText({txt: trText, fontname: `${fontFamily}`, fontsize: `${fontSize}px`});
        return { ...text, origLength, trText, trLength };
      })

      const origLengthArr = trTextArr.map((trText)=>{
        return trText.origLength;
      })

      const trLengthArr = trTextArr.map((trText)=>{
        return trText.trLength;
      })

      const indexOfMaxOrigValue = origLengthArr.reduce((iMax, x, i, arr) => x > arr[iMax] ? i : iMax, 0);
      const indexOfMaxTrValue = trLengthArr.reduce((iMax, x, i, arr) => x > arr[iMax] ? i : iMax, 0);

      const defaultLongestLength = trTextArr[indexOfMaxOrigValue].origLength;
      const trLongestLength = trTextArr[indexOfMaxTrValue].trLength;


      const expandBy = trLongestLength - defaultLongestLength;

      return {
        trTextArr,
        trLongestLength,
        defaultLongestLength,
        expandBy
      }

  }

  buildBackLegend(){

      this.backlegendWidth = 427;
      const legendHeight = 131;
      const backLegendFontSize = 17;

      const legendCanvas2 = document.getElementById("legendCanvas2");
      const ctx = legendCanvas2.getContext("2d");


      /*
          Clear residual canvas if repeat rendering without clicking cancel.
       */

      ctx.save();

      ctx.setTransform(1, 0, 0, 1, 0, 0);
      ctx.clearRect(0, 0, this.backlegendWidth, legendHeight);

      ctx.restore();





      /*
       *  Expand and Translate
       */

      let rightX = 285;

      const defaultLeftLegendArr = [{
        content: `Tree focus`,
        description: 'Tree legend',
      },{
        content: `Female`,
        description: 'Tree legend',
      },{
        content: `Male`,
        description: 'Tree legend',
      },{
        content: `Unknown`,
        description: 'Tree legend',
      }];

      const leftLegendArr = this.getExpandedTrLengthObj({
        textArr: defaultLeftLegendArr,
        fontFamily,
        fontSize: backLegendFontSize
      });


      this.shiftRightForBackRightLegendColumn = leftLegendArr.expandBy;

      this.moreBackLegendLength = leftLegendArr.expandBy;
      let rightLegendArray = [{
        content: `Direct relation`,
        description: 'Legend Directly related union line',
        // length: 112.91552734375,
      },{
        content: `Ex-spouse`,
        description: 'Legend Separated union line',
        // length: 80.70849609375,
      },{
        content: `Other marriages`,
        description: 'Legend Muliple union lines',
        // length: 130.43017578125,
      }];

      rightLegendArray = this.getExpandedTrLengthObj({
        // defaultLongestLength: 130.43017578125,
        textArr: rightLegendArray,
        fontFamily,
        fontSize: backLegendFontSize
      });

      this.moreBackLegendLength += rightLegendArray.expandBy;




      /*
       *  Rectangle Container
       */

      ctx.beginPath();
      ctx.lineWidth = '.5';
      ctx.rect(10, 10, this.backlegendWidth + this.moreBackLegendLength, legendHeight);
      ctx.strokeStyle = "black";
      ctx.stroke();


      /*
       *  Title
       */

      let shiftRightForRtl = 390;
      if( isMobilePhone ) shiftRightForRtl -= 20;
      ctx.font = `Bold 23px ${fontFamily}`;
      ctx.fillStyle = "blue";
      ctx.fillText(this.translate(`Legend`, 'Legend Label'), ( isRtl ? 25 + shiftRightForRtl : 25), 40);


      /*
       *  Legend
       */

      ctx.font = `${backLegendFontSize}px ${fontFamily}`;
      ctx.fillStyle = "gray";
      let leftX = 78;
      shiftRightForRtl = 290;
      if( isMobilePhone ) shiftRightForRtl -= 30;
      if( isRtl ) leftX += shiftRightForRtl;
      const bothShiftY = 24;



      /*
       *  Left
       */

      ctx.fillText(leftLegendArr.trTextArr[0].trText, leftX, 45 + bothShiftY);

      if( !this.state.bw ){
        ctx.fillText(leftLegendArr.trTextArr[1].trText, leftX, 65 + bothShiftY);
        ctx.fillText(leftLegendArr.trTextArr[2].trText, leftX, 85 + bothShiftY);
        ctx.fillText(leftLegendArr.trTextArr[3].trText, leftX, 105 + bothShiftY);
      }



      /*
       *  Right
       */


      shiftRightForRtl = -120;
      if( isRtl ) rightX += shiftRightForRtl;

      ctx.fillText(rightLegendArray.trTextArr[0].trText, rightX + this.shiftRightForBackRightLegendColumn, 45 + bothShiftY);
      ctx.fillText(rightLegendArray.trTextArr[1].trText, rightX + this.shiftRightForBackRightLegendColumn, 68 + bothShiftY);
      ctx.fillText(rightLegendArray.trTextArr[2].trText, rightX + this.shiftRightForBackRightLegendColumn, 93 + bothShiftY);


      /*
       *  Small Rectangle Focus
       */

      let leftPadding = 25;
      let my_gradient = undefined;
      const rectShiftDown = 10;


      // shiftRightForRtl = 360;
      shiftRightForRtl = 360;
      if( isMobilePhone ) shiftRightForRtl -= 30;
      if( isRtl ) leftPadding += shiftRightForRtl;

      if( this.state.bw ){
        my_gradient = ctx.createLinearGradient(0, 0, 0, 170);
        my_gradient.addColorStop(0, "#E7E7E7");
        my_gradient.addColorStop(1, "#D3D3D3");
        ctx.fillStyle = my_gradient;
        ctx.fillRect(leftPadding, 45 + rectShiftDown, 40, 15);
      }
      ctx.beginPath();
      ctx.lineWidth = '.5';
      ctx.rect(leftPadding, 45 + rectShiftDown, 40, 15);
      ctx.strokeStyle = "black";
      ctx.stroke();

      if( !this.state.bw ){
        /*
         *  Small Rectangle Female
         */
        my_gradient = ctx.createLinearGradient(0, 0, 0, 170);
        my_gradient.addColorStop(0, "#FFD8DE");
        my_gradient.addColorStop(1, "#F6B8DB");
        ctx.fillStyle = my_gradient;
        ctx.fillRect(leftPadding, 65 + rectShiftDown, 40, 15);
        ctx.beginPath();
        ctx.lineWidth = '.5';
        ctx.rect(leftPadding, 65 + rectShiftDown, 40, 15);
        ctx.strokeStyle = "black";
        ctx.stroke();


        /*
         *  Small Rectangle Male
         */

        my_gradient = ctx.createLinearGradient(0, 0, 0, 170);
        my_gradient.addColorStop(0, "#A9CFE7");
        my_gradient.addColorStop(1, "#A9CFE7");
        ctx.fillStyle = my_gradient;
        ctx.fillRect(leftPadding, 85 + rectShiftDown, 40, 15);
        ctx.beginPath();
        ctx.lineWidth = '.5';
        ctx.rect(leftPadding, 85 + rectShiftDown, 40, 15);
        ctx.strokeStyle = "black";
        ctx.stroke();

        /*
         *  Small Rectangle Ungendered
         */

        my_gradient = ctx.createLinearGradient(0, 0, 0, 170);
        my_gradient.addColorStop(0, "#C8F176");
        my_gradient.addColorStop(1, "#C8F176");
        ctx.fillStyle = my_gradient;
        ctx.fillRect(leftPadding, 105 + rectShiftDown, 40, 15);
        ctx.beginPath();
        ctx.lineWidth = '.5';
        ctx.rect(leftPadding, 105 + rectShiftDown, 40, 15);
        ctx.strokeStyle = "black";
        ctx.stroke();

      }

      /*
       *  Line
       */

      let XBegin = 200 + this.shiftRightForBackRightLegendColumn;
      let XEnd = 270 + this.shiftRightForBackRightLegendColumn;
      shiftRightForRtl = -20;

      if( isRtl ){
        XBegin += shiftRightForRtl;
        XEnd += shiftRightForRtl;
      }
      let Ylevel = 53;
      ctx.beginPath();
      ctx.lineWidth = 1;
      ctx.moveTo(XEnd, Ylevel + rectShiftDown );
      ctx.lineTo(XBegin, Ylevel + rectShiftDown );
      ctx.stroke();

      /*
       *  Line 2
       */

      Ylevel = 73;
      ctx.beginPath();
      ctx.setLineDash([5, 3]);
      ctx.moveTo(XEnd, Ylevel + rectShiftDown );
      ctx.lineTo(XBegin, Ylevel + rectShiftDown );
      ctx.stroke();


      /*
       *  Line 3
       */

      Ylevel = 93;
      ctx.setLineDash([]);
      ctx.strokeStyle = "#085294";
      ctx.beginPath();
      ctx.moveTo(XEnd, Ylevel + rectShiftDown );
      ctx.lineTo(XBegin, Ylevel + rectShiftDown );
      ctx.stroke();

      Ylevel += 8;
      ctx.beginPath();
      ctx.strokeStyle = "#FF0000";
      ctx.moveTo(XEnd, Ylevel + rectShiftDown );
      ctx.lineTo(XBegin, Ylevel + rectShiftDown );
      ctx.stroke();

      Ylevel += 8;
      ctx.beginPath();
      ctx.strokeStyle = "#9C00FF";
      ctx.moveTo(XEnd, Ylevel + rectShiftDown );
      ctx.lineTo(XBegin, Ylevel + rectShiftDown );
      ctx.stroke();



      if( this.state.bw ){
        var imgPixels = ctx.getImageData(0, 0, this.backlegendWidth, legendHeight);
        for(var y = 0; y < imgPixels.height; y++){
         for(var x = 0; x < imgPixels.width; x++){
              var i = (y * 4) * imgPixels.width + x * 4;
              var avg = (imgPixels.data[i] + imgPixels.data[i + 1] + imgPixels.data[i + 2]) / 3;
              imgPixels.data[i] = avg;
              imgPixels.data[i + 1] = avg;
              imgPixels.data[i + 2] = avg;
         }
        }
        ctx.putImageData(imgPixels, 0, 0, 0, 0, imgPixels.width, imgPixels.height);
      }

      const dataURL = legendCanvas2.toDataURL();

      const legendImg2 = document.getElementById("legendImg2");
      legendImg2.src = dataURL;
      return dataURL;
  }

  createDocDefinition(){

    const cloned = cloneDeep(this.pdfContentArray);

    const that = this;
    this.docDefinition = {

      /*
        header: function(currentPage, pageCount, pageSize) {
          // you can apply any logic and return any valid pdfmake element

          return [
            { text: 'Geni Tree', alignment: 'left' },
            { canvas: [ { type: 'rect', x: 0, y: 32, w: 170, h: 40 } ] }
          ]
        },

        info: {
          title: 'Geni Document',
          author: 'john doe',
          subject: 'subject of document',
          keywords: 'keywords for document',
        },
      */

      defaultStyle: {
        fontSize: 10,
        bold: false,
      },
      pageSize: this.state.pageSize.toUpperCase(),
      pageOrientation: 'landscape',
      // pageMargins: [ 50, 50, 0, 50 ],
      content: cloned,
      // watermark: { text: 'test watermark', color: 'blue', opacity: 0.3, bold: true, italics: false },
      background: function (page) {
        const yPos = (that.state.pageSize === 'tabloid' ? 688: 500)
        // const backlegendWidth = 450;

        let legendArray = [{
            image: 'legend',
            width: 350,
            absolutePosition: { x: 20, y: yPos - that.shiftLegendBoxUp}
          },

        ];

        let backLegendArray = [{
          image: 'backlegend',
          width: that.backlegendWidth,
          absolutePosition: { x: (that.pdfPrintWidth + 238 - (that.moreBackLegendLength/1.9)) - (that.backlegendWidth), y: yPos }
        }];

        if( that.verySmallTree ){
          legendArray.push(backLegendArray)
        }

        if (page === 1 && that.state.legend ) {
          return legendArray;
        }

        if (page === that.state.page && that.state.legend ) {
          return backLegendArray;
        }

      },
      images: {
        legend: that.buildFrontLegend(),
        backlegend: cloneDeep(that.buildBackLegend()),
        // backlegend: that.buildBackLegend(),
      }
    }

    let ofStr =  typeof(window.trl) !== 'undefined' ? window.trl('of', 'PDF page count'): 'of'
    if( this.state.pagenumber) this.docDefinition = { ...this.docDefinition, footer: function(currentPage, pageCount) { return { text: `${currentPage.toString()} ${ofStr} ${pageCount}`, alignment: 'center' } },}

  }

  createPDF(){
    this.createDocDefinition();
    if(isIE() ){
      pdfMake.createPdf(this.docDefinition).download();
      return;
    }
    pdfMake.createPdf(this.docDefinition).open(); // .print()
  }

  stageCanvasPrint(){

       if( this.props.downloadingPedigreeChart )  return;

       this.props.setStagePrintDownloadingTo(true);
       if(this.props.chartType === 'fan') this.props.fanchartCurrent.isPrint(true);

        setTimeout(() => {

          const stagePrint = this.props.stagePrintCurrent.clone();

          const configHash = {
            'horizontal': {
              scale: 11,
              width: 7200 /  1.2,
              height: 4800 /  1.2,
            },
            'fan': {
              scale: 3.75,
              width: (7200 /  1.2),
              height: 4800 /  1.2,
            },
          }

          if(this.props.chartType === 'fan'){
            const levelAddHash = {
              4: {
                x: -2050,
                y: -1800,
                scale: 3,
              },
              5: {
                x: -1490,
                y: -1150,
                scale: 2.1,
              },
              6: {
                x: -600,
                y: -400,
                scale: .8,
              },
              7: {
                x: 0,
                y: 0,
                scale: 0,
              },
              8: {
                x: 0,
                y: 0,
                scale: 0,
              }
            }

            let ancestors = isDevelopment ? urlGet('levels') : this.props.ancestors;
            ancestors = (this.props.maxAncestorGen < this.props.ancestors ? this.props.maxAncestorGen: this.props.ancestors)
            if( ancestors < 4 ) ancestors = 4;

            stagePrint.position({
              x: 200 + levelAddHash[ancestors].x,
              y: 800 + levelAddHash[ancestors].y,
            });

            const sizeObj = {
              width: configHash[this.props.chartType].width - 300,
              height: configHash[this.props.chartType].height
            }

            console.log(`sizeObj: `, JSON.stringify(sizeObj, null, 2));

            stagePrint.size(sizeObj);


            stagePrint.scale({
                x: configHash[this.props.chartType].scale  + levelAddHash[ancestors].scale,
                y: configHash[this.props.chartType].scale  + levelAddHash[ancestors].scale
              }
            );

          } else {

            stagePrint.position({
              x: 400,
              y: 100
            });

            stagePrint.size({
              width: configHash[this.props.chartType].width,
              height: configHash[this.props.chartType].height
            });


            stagePrint.scale({
              x: configHash[this.props.chartType].scale,
              y: configHash[this.props.chartType].scale}
            );

          }

          this.downloadPDFForStagePrint(stagePrint.toDataURL());
          this.props.setStagePrintDownloadingTo(false);

          setTimeout(() => {
            if(this.props.chartType === 'fan') this.props.fanchartCurrent.isPrint(false);
          }, 400);

        }, 800);

  }

  downloadPDFForStagePrint(content){

    const that = this;

    const pageObj = {
      image: content,
      width: 717,
      height: 511,
      margin: [ 0, 0, 0, 0]
    }
    const docDefinition = {

      defaultStyle: {
        fontSize: 10,
        bold: false,
      },
      pageSize: 'letter',
      pageOrientation: 'landscape',
      content: [pageObj],
      background: [{
        image: 'legend',
        width: 200,
        absolutePosition: { x: this.props.chartType === 'fan' ? 325: 50, y: 510}
      }],
      images: {
        legend: that.buildFrontLegend()
      }
    };

    pdfMake.createPdf(docDefinition).open();

    this.props.setStagePrintDownloadingTo(false);

  }

}

export default Pdf;

